module.exports = __webpack_public_path__ + "assets/ivc-select-vehicles.ab1c9361.svg";